export default __webpack_public_path__ + "static/media/smile.16284685.svg";